import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./Routes";
import Loading from "./components/Loading";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <Routes />
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
